"use client";

import Link from "next/link";
import { useOrgHref } from "@/hooks/useOrgHref";
import type { ToolQuotaError } from "@/hooks/useToolFetch";

interface UsageLimitBannerProps {
  quotaError: ToolQuotaError;
}

export default function UsageLimitBanner({ quotaError }: UsageLimitBannerProps) {
  const orgHref = useOrgHref();
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <svg
            className="h-5 w-5 text-amber-600 shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
          </svg>
          <p className="text-sm text-amber-800">
            <strong>Daily limit reached</strong> ({quotaError.used}/{quotaError.limit}).
            Resets at midnight UTC.
          </p>
        </div>
        <Link
          href={orgHref("/dashboard/billing")}
          className="shrink-0 rounded-md bg-brand-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-brand-700 transition-colors whitespace-nowrap"
        >
          Upgrade
        </Link>
      </div>
    </div>
  );
}
